/**
 * @format
 * @flow
 */
import React from "react";
import { Redirect } from "react-router-dom";
// import { connect } from 'react-redux';
import * as RT from "../constants/Routing";

export default class Root extends React.Component {
  render = () => {
    return <Redirect to={RT.SIGN_IN_PATH} />;
  };
}
